import { allSwatchValue, PDPBuilderType, PropsFromScreenManager, TableData } from '../../types';
import { useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { iFrameHost } from '../BuildOwn/BuildOwn';
import { useNavigate } from 'react-router-dom';
import { propertyMappings, source } from '../Diamond/useDiamond';
import { TooltipDataFetch } from '../Tooltip/TooltipDataFetch';
import { buildYourOwnValue, findNearestValue, fitToAvailableSize, startWithSettingValue } from '../../Utils/findNearestCaratValue';
import { getRingPrice } from '../../Utils/getRingPriceValue';
import { getDiamondCode } from '../../Utils/getDiamondCode';
import { getNoBands } from '../../Utils/getNoBands';
import { exclusionMatrixData, getExclusionOptions } from '../../Utils/getExclusionOptions';
import { initialExclusionKey } from '../../Utils/initialExclusionKey';
import { ringSettingParams } from '../../constant/generalData';
import CONSTANTS from "../../constant/general";
import {
  getBuildSearchParams,
  getDiamondId,
  getKeyByValue,
  getLocalStorageData,
  getThreeDFileName
} from '../../Utils/general';
import { useFinalizeYourDesign } from "../FinalizeYourDesign/useFinalizeYourDesign";

declare global {
  interface Window {
    _category: string;
    _earring_back: string;
  }
}
const Ring_Attributes = [ 'Ring_Crown', 'Ring_Side', 'Ring_Style' ];
const usePdpBuilder = (props: PDPBuilderType & PropsFromScreenManager, showCrownMetal?: boolean) => {

  const {
    ring,
    diamond,
    footer,
    header,
    settingFilter,
    setSelectedRingDetails,
    setSelectedDiamondLoading,
    setSelectedDiamondData,
    setSelectedDiamondFail,
    setRingOptions,
    setOptionsLoading,
    setOptionsData,
    setOptionsFail,
    setDiamondDetailsLoading,
    setDiamondDetailsFail,
    setDiamondDetailsSuccess,
    SetTooltipDataSuccess,
    setTooltipDataLoading,
    SetTooltipDataError,
    setStyleID,
    setIframeLoadActionCount,
    setPriceLoading,
    setRingPrice,
    setRingPriceError,
    setRingExtraData,
    setBandTabIndex,
    setIsShowFooter,
    setFooterToggle,
    setAfterRingOptions,
    setSettingTabIconTrue,
    setExclusionOption,
    setRedirectEditPage,
    setRemoveRingOption,
    setIsHandLoaded,
    setIsEngraving,
    instanceData: { screenManager },
    iframeLoadActionCount,
    changeBackClick,
    setInitialOption,
    setIsDisabledThumbnail,
    setJourney,
  } = props;

  const { loading, handleFinalizeYourDesign } = useFinalizeYourDesign();

  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const [ isDisabledOption, setIsDisabledOption ] = useState<boolean>(false);
  // const match_styleId = currentUrl.match(/styleId=([^&]*)/);
  // const match_diamondId = currentUrl.match(/diamondId=([^&]*)/);
  // // const styleId = match_styleId?.[1].split('/')[0] || '';
  // const diamondId = match_diamondId?.[1] || '';
  const diamondId = getDiamondId(currentUrl);
  const [ showError, setShowError ] = useState<boolean>(false);
  const [ productName, setProductName ] = useState<string>('')
  const hasEffectRun = useRef(false);
  const lastProcessedCommand = useRef<string | undefined>(undefined);
  const [ fieldValidation, setFieldValidation ] = useState<string[]>([])
  const rpid = getLocalStorageData(CONSTANTS.RPID);
  const builder_mode = getLocalStorageData(CONSTANTS.BUILDER_MODE_KEY);
  const uuid = getLocalStorageData(CONSTANTS.DESIGN_UUID);
  const [ weddingBand, setWeddingBand ] = useState<string[]>([ 'No Band', 'Single', 'Double' ])
  // const weddingBand = ['No Band','Single','Double'];
  const { ring_price, left_band_price, right_band_price } = ring.ringPrice;
  const [ exclusionMatrix, setExclusionMatrix ] = useState<{ [key: string]: string }[]>([]);
  const [ isFirstTimeHandShake, setIsFirstTimeHandShake ] = useState<boolean>(false);
  const [ isHandShakeReturnInternal, setIsHandShakeReturnInternal ] = useState<boolean>(false);
  const hasNormalisedMetalParamRef = useRef(false);

  const extractParams = useCallback((url: string) => {
    const paramsObj: Record<string, string> = {};

    const fragment: string = url.split('#')[1] || '';

    // const fragmentParts = fragment.split('/');
    const [ pathname, queryParams = "" ] = fragment.split('?');
    const fragmentParts = pathname.split('/');
    const queryPart = fragmentParts.find(part => part.includes('styleId'));

    queryPart?.split('&').forEach((param) => {
      const [ key, value ] = param.split('=');
      if (key && value) {
        paramsObj[key] = value;
      }
    });

    return paramsObj;
  }, [ currentUrl ]);

  useEffect(() => {
    if (ring.extraData.Bands === 2) {
      setWeddingBand([ 'No Band', 'Single', 'Double' ]);
    } else if (ring.extraData.Bands === 1) {
      setWeddingBand([ 'No Band', 'Single' ]);
    }
  }, [ ring.extraData.Bands ])

  const urlData = useMemo(() => {
    return (screenManager as any).parseURL(window.location.href);
  }, [ screenManager, window.location.href ]);
  const isStuds = useMemo(() => urlData.command === 'stud-earrings', [ urlData.command ]);
  const isListingRing = useMemo(() => urlData.command === 'setting', [ urlData.command ]);
  const isSettingPage = useMemo(() => [ "stud-earrings", "setting" ].includes(urlData.command), [ urlData.command ]);
  const ringPrice = useMemo(() => {
    if (ring_price) {
      if(isStuds){
        const diaQuality = ring.options["Diamond_Quality"];
        return  diaQuality === "GOOD"? ring_price: diaQuality === "BETTER" ? left_band_price : diaQuality === "BEST" ? right_band_price : 0
      }
      return +ring_price
    }
    return 0
  }, [ isStuds, ring_price, ring.options["Diamond_Quality"]]) /*+ (ring.options.Wedding_Band !== weddingBand[0] ? ring.options.Wedding_Band === weddingBand[1] ? left_band_price : (left_band_price+right_band_price)  :0)*/;
  const styleId = useMemo(() => {
    return urlData?.params?.styleId;
  }, [ urlData?.params?.styleId ]);
  const isSideStone = useMemo(() => ring.options.Side_Stones === 'DIA' ? '' : `and ${ring.selectedRingDetails.Side_Stones}`, [ ring.options.Side_Stones, ring.selectedRingDetails.Side_Stones ]);
  const handleReviewClick = async () => {
    await handleFinalizeYourDesign(isStuds);
  };
  useEffect(() => {
    window._category = isStuds ? CONSTANTS.STUD_CATEGORY_CODE : CONSTANTS.RING_CATEGORY_CODE;
  }, [isStuds]);
  useEffect(() => {
    const { Diamond_Type, Diamond_Shape, Ring_Style, Color, Metal } = ring.selectedRingDetails;
    const { Label } = ring.extraData;
    if (Object.keys(ring.selectedRingDetails).length > 0) {
      setProductName(`${(Label?.toLowerCase() !== "generic" && Label) ? ((Label === 'Reve') ? 'rêve ':`${Label} `) : ''}${isStuds ? `${Ring_Style} ${Diamond_Shape} ${Diamond_Type ? `${Diamond_Type} Diamond`: ''} Stud Earrings in ${Metal} ${Color ? Color : ''} ${Metal?.toLowerCase() !== "platinum" ? 'Gold' : ''}` : `${Ring_Style} ${Diamond_Type} Diamond ${isSideStone} Setting in ${Metal} ${Color ? Color : ''} ${Metal?.toLowerCase() !== "platinum" ? 'Gold' : ''} ${(ring.options.Wedding_Band && ring.options.Wedding_Band !== 'No Band') ? ring.options.Wedding_Band === 'Single' ? ' with Wedding Band' : ' with Wedding Bands' : ''}`}`)
    }
  }, [ ring.selectedRingDetails, ring.extraData, ring.options ])

  useEffect(() => {
    if (Object.keys(ring.options).length > 0 && Object.keys(ring.optionsData).length > 0) {
      Object.entries(ring.options).map(([ key, value ]) => {
        const allValue = ring.optionsData[[ 'Metal', 'Color', 'Crown_Metal', 'Crown_Color' ].includes(key) ? 'Metal_Color' : key];
        if (allValue) {
          const findSwatchValue = (allValue as allSwatchValue[]).find(
            (a) => [ 'Metal', 'Color' ].includes(key) ? a.Code === `${ring.options.Metal}_${ring.options.Color}` : [ 'Crown_Metal', 'Crown_Color' ].includes(key) ? a.Code === `${ring.options.Crown_Metal}_${ring.options.Crown_Color}` : a.Code === value
          );
          if (findSwatchValue) {
            if ([ "Metal", "Color" ].includes(key)) {
              const metalColor = {
                "Metal": (findSwatchValue.Name as string)?.split(' ')[0],
                "Color": (findSwatchValue.Name as string)?.split(' ')[1],
              }
              Object.entries(metalColor).forEach(([ key, value ]) => setSelectedRingDetails(key, value))
            } else if ([ 'Crown_Metal', 'Crown_Color' ].includes(key)) {
              const crown = {
                'Crown_Metal': (findSwatchValue.Name as string)?.split(' ')[0],
                'Crown_Color': (findSwatchValue.Name as string)?.split(' ')[1]
              };
              Object.entries(crown).forEach(([ key, value ]) => setSelectedRingDetails(key, value));
            } else {
              setSelectedRingDetails(
                key,
                findSwatchValue.Name as string
              );
            }

          }
        }
      });
      if ("Engraving" in ring.options) {
        setSelectedRingDetails("Engraving", ring.options["Engraving"])
      }
    }
  }, [ ring.options, ring.optionsData ]);
  useEffect(() => {
    const controller = new AbortController();
    if (Object.keys(ring.options).length > 0) {
      const { Ring_Style, Ring_Side, Crown_Metal, Metal, Color } = ring.options;
      if (Ring_Style && Ring_Side && Metal && Color) {
        const {
          Ring_Crown,
          Diamond_Shape,
          Center_Diamond_Size,
          Diamond_Type,
          Wedding_Band,
          Side_Stones,
          Earring_Back
        } = ring.options;
        // const ringPriceData = `${styleId}-${Ring_Style}${Ring_Crown}-${Diamond_Shape}-${Center_Diamond_Size}-${Ring_Side}-${Metal}-${Color}-${Diamond_Type}`;
        let ringPriceData = "";
        if(isStuds){
          ringPriceData = `${styleId}-${Ring_Style}${Ring_Crown}-${Diamond_Shape}-${Center_Diamond_Size}-${Ring_Side}-${(Crown_Metal ?? Metal)}-${Metal}-WG-${Diamond_Type}-${Side_Stones}-${Earring_Back}`;
        }else {
          ringPriceData = `${styleId}-${Ring_Style}${Ring_Crown}-RND-${Center_Diamond_Size}-${Ring_Side}-${(Crown_Metal ?? Metal)}-${Metal}-WG-${Diamond_Type}-${Side_Stones}`;
        }
        if (ringPriceData && (Wedding_Band || isStuds)) {
          const priceData = {
            sku: `'${ringPriceData}'`, order_items: Wedding_Band === 'Single' ? 2 : Wedding_Band === 'Double' ? 3 : 1
          }
          getRingPrice(setPriceLoading, setRingPrice, setRingPriceError, priceData, controller.signal);
        }
      }
    }
  }, [ isStuds, styleId, ring.options['Ring_Style'], ring.options['Side_Stones'], ring.options['Ring_Crown'], ring.options['Diamond_Shape'], ring.options['Center_Diamond_Size'], ring.options['Ring_Side'], ring.options['Crown_Metal'], ring.options['Metal'], ring.options['Color'], ring.options['Diamond_Type'], ring.options['Wedding_Band'], ring.options["Earring_Back"] ])

  const [ pendingEvents, setPendingEvents ] = useState<{ [key: string]: string | boolean }[]>([]);
  const iframeAction = useRef<{ [key: string]: string | boolean }[]>([]);

  useEffect(() => {
    iframeAction.current = [ ...pendingEvents ];
  }, [ pendingEvents ])
  const handleMessageEvent = useCallback((event: any) => {
    const afterDesignLoaded = [ 'ChangeRingColor', 'ChangeCrownColor', 'LeftBand', 'RightBand', 'ChangeLeftBandColor', 'ChangeRightBandColor', "ChangeSideStone", "EarringBack" ];
    const origin = event.origin || event?.originalEvent.origin;
    // console.log(origin, 'origin', event.data);
    if (origin === window.location.origin) {
      if (event.data.action === 'HandshakeIntegration') {
        window.postMessage({ action: 'HandshakeInternal' });
      }
      if ((event.data.action === 'HandshakeReturnInternal' || isHandShakeReturnInternal) && !isFirstTimeHandShake) {
        setIsFirstTimeHandShake(true);
        setIsHandShakeReturnInternal(true);
        iframeAction.current
          .filter((model) => !afterDesignLoaded.includes(model.action as string))
          .forEach((data) => {
            window.postMessage(data);
          });
      }
      if (event.data.action === 'IsChangeViewStart') {
        setIsDisabledThumbnail(true);
      } else if (event.data.action === 'IsChangeViewDone') {
        setIsDisabledThumbnail(false);
      }
    }
    if (origin === iFrameHost) {
      if (event.data.action === 'DesignLoaded') {
        afterDesignLoadEvent(iframeAction, afterDesignLoaded);
      }
      if (event.data.action === 'HandLoaded') {
        setIsHandLoaded(true);
      }
    }
    if (event.data.action === 'DesignLoadError') {
      afterDesignLoadEvent(iframeAction, afterDesignLoaded);
    }
  }, [ isHandShakeReturnInternal, isFirstTimeHandShake, iframeAction, iFrameHost, setIsHandLoaded ]);

  useEffect(() => {
    // console.log("REMOVE EVENT LISTENER STYLE_ID USFFECT");
    window.removeEventListener('message', handleMessageEvent);
    setPendingEvents([]);
  }, [ styleId, urlData?.command ]);

  useEffect(() => {
    // console.log(iframeAction.current,"iframeAction.current")
    if (iframeAction.current.length > 0) {
      window.addEventListener("message", handleMessageEvent);
      window.postMessage({ action: 'HandshakeInternal' });
    }
    return () => {
      if (iframeAction.current.length > 0) {
        // console.log("REMOVE EVENT LISTENER");
        window.removeEventListener("message", handleMessageEvent);
      }
    };
  }, [ pendingEvents, handleMessageEvent ]);
  const afterDesignLoadEvent = (iframeAction: React.MutableRefObject<{
    [p: string]: string | boolean
  }[]>, afterDesignLoaded: string[]) => {
    setIframeLoadActionCount(count => {
      const updatedCount = count - 1;
      // console.log(updatedCount,"updatedCount")
      if (updatedCount === 0) {
        iframeAction.current.filter(model => afterDesignLoaded.includes(model.action as string)).forEach((data) => {
          window.postMessage(data);
        });
        window.postMessage({
          action: 'SwitchCameraView'
        })
      }
      return updatedCount;
    });
  }
  useEffect(() => {
    if (iframeLoadActionCount === 0) {
      setIsEngraving(false);
    }
  }, [ iframeLoadActionCount ]);
  const handle3DObjectView = useCallback((key: string, value: string | boolean) => {
    setPendingEvents((prev) => {
      return [ ...prev, { action: key, value } ];
    });
  }, [ setPendingEvents ]);

  const optionsData = useCallback(async (selectedDiamond: {
    [key: string]: string
  }, shape: string | null, signal: AbortSignal | null, params: { [key: string]: string }) => {
    setOptionsLoading();
    try {
      const obj = {
        [CONSTANTS.JOURNEY]:      urlData?.command,
        [CONSTANTS.RING_BUILDER]: styleId,
        ...(params[ringSettingParams.Ring_Crown] && { [ringSettingParams.Ring_Crown]: params[ringSettingParams.Ring_Crown] }),
        ...(params[ringSettingParams.Ring_Style] && { [ringSettingParams.Ring_Style]: params[ringSettingParams.Ring_Style] }),
        ...(params[ringSettingParams.Ring_Side] && { [ringSettingParams.Ring_Side]: params[ringSettingParams.Ring_Side] })
      }
      const urlParams = new URLSearchParams(obj);

      const response = await fetch(`${process.env.REACT_APP_PDP_OPTIONS_KEY}?${urlParams}`, { signal: signal as AbortSignal });

      if (!response.ok) {
        setOptionsFail(new Error(`HTTP error! Status: ${response.status}`));
        return;
      }

      const result = await response.json();
      const {
        Diamond_Type,
        Diamond_Quality,
        Diamond_Shape,
        Ring_Crown,
        Ring_Side,
        Ring_Style,
        Ring_Size,
        Metal_Color,
        Center_Diamond_Size,
        // Center_Diamond_Total_Carat_Weight,
        Extra_Data,
        Side_Stones,
        Earring_Back
      } = result;

      const newResult: { [key: string]: any } = {
        ...(Ring_Style && { Ring_Style }),
        ...(Diamond_Shape && { Diamond_Shape }),
        ...(Diamond_Type && { Diamond_Type }),
        ...(Center_Diamond_Size && { Center_Diamond_Size }),
        ...(Diamond_Quality && { Diamond_Quality }),
        ...(Side_Stones && { Side_Stones }),
        ...(Ring_Crown && { Ring_Crown }),
        ...(Ring_Side && { Ring_Side }),
        ...(Metal_Color && { Metal_Color, Crown_Metal_Color: Metal_Color, }),
        ...(Earring_Back && { Earring_Back }),
        ...(Ring_Size && { Ring_Size }),
      };
      const customisationAllowed = Extra_Data.customisation_allowed;
      if (Object.keys(params).length > 0) {
        const hasInvalidParams = Object.entries(params).some(([ key, value ]) => {
          const paramKey = getKeyByValue(ringSettingParams, key);
          const metal = params?.[CONSTANTS.METAL]?.split("_")?.[0];
          const isColourOnlyMetalParam =
            [ 'Metal_Color', 'Crown_Metal_Color' ].includes(paramKey as string) &&
            typeof value === 'string' && value.startsWith('_');
          const colourHalf = typeof value === 'string' ? value.split('_')[1] : undefined;
          return (
            (paramKey &&
            newResult[paramKey] &&
              !Object.values(newResult[paramKey]).some((entry: any) =>
                entry.Code === value ||
                (isColourOnlyMetalParam && !!colourHalf && entry.Code?.split('_')[1] === colourHalf))) ||
            (isStuds && Object.keys(params).includes(CONSTANTS.METAL) && metal === "PT" && key === CONSTANTS.Earring_Back && value === "GRD")
          );
        });

        if (hasInvalidParams) {
          (screenManager as any).changeScreen({
            viewName:     urlData?.command,
            styleId,
            searchParams: getBuildSearchParams(window.location)
          });

          // Reset state and reload options
          setPendingEvents([]);
          setIframeLoadActionCount(0);
          await optionsData({}, null, signal, {});
          return;
        }
      }
      if (params && params.size) {
        setRingOptions('Ring_Size', params.size);
      }
      if (params && params[ringSettingParams.Wedding_Band]) {
        const band = params[ringSettingParams.Wedding_Band];
        isEditableRingOptions.current = true;
        setRingOptions('Wedding_Band', band);
        setBandTabIndex(band === 'Double' ? 2 : band === weddingBand[0] ? 0 : 1);
        const firstMetal = params[ringSettingParams.First_Band_Metal];
        const secondMetal = params[ringSettingParams.Second_Band_Metal];
        if (firstMetal) {
          setRingOptions(`${band}_First_Metal_Band`, firstMetal);
          setRingOptions(`${band}_First_Band`, firstMetal.split('_')[1]);
        }
        if (secondMetal && band === 'Double') {
          setRingOptions('Double_Second_Metal_Band', secondMetal);
          setRingOptions('Double_Second_Band', secondMetal.split('_')[1]);
        }
      }
      if (!customisationAllowed) {
        delete newResult['Crown_Metal_Color'];
      }

      const availableSizeCodes = (newResult["Center_Diamond_Size"] as { Code: string }[] | undefined)?.map(option => option.Code);
      const wantedDiamondSize = selectedDiamond["Center_Diamond_Size"] || ring.options["Center_Diamond_Size"];
      const fittedDiamondSize = fitToAvailableSize(wantedDiamondSize, availableSizeCodes);
      if (fittedDiamondSize && fittedDiamondSize !== wantedDiamondSize) {
        if (selectedDiamond["Center_Diamond_Size"]) {
          selectedDiamond = { ...selectedDiamond, Center_Diamond_Size: fittedDiamondSize };
        }
        setRingOptions("Center_Diamond_Size", fittedDiamondSize);
      }
      const initialBuilderDiamondSize = "100";
      const GNUDiamondSize = "100";
      const Exclusion_Matrix = await exclusionMatrixData(styleId, isStuds ? CONSTANTS.STUD_CATEGORY_CODE : CONSTANTS.RING_CATEGORY_CODE);
      setExclusionMatrix(Exclusion_Matrix);
      const modelInitialData: { [key: string]: string } = {};
      const selectedDiamondSize = settingFilter.options["Center_Diamond_Type"] === "GNU" ? GNUDiamondSize : settingFilter.options["Center_Diamond_Size"];
      if ((!(rpid && uuid) && builder_mode !== CONSTANTS.EDIT) || !(Object.keys(ring.options).length > 0)) {
        Object.entries(newResult).forEach(([ key, value ]) => {
          if ([ "Ring_Crown", "Center_Diamond_Size", "Ring_Side" ].includes(key)) {
            modelInitialData[key] = key === "Center_Diamond_Size" ? (selectedDiamond["Center_Diamond_Size"] || params[ringSettingParams[key]] || (isSettingPage ? ring.options[key] || selectedDiamondSize || value[0].Code : ring.options[key] || initialBuilderDiamondSize)) : (params[ringSettingParams[key]] || ring.options[key] || settingFilter.options[key] || value[0].Code)
          } else if ("Ring_Style" === key) {
            modelInitialData[key] = params[ringSettingParams[key]] || ring.options[key] || value[0].Code;
          }
          if (key !== "Ring_Size") {
            const metalColor = params[ringSettingParams.Metal_Color]?.split('_')[1] || ring.options["Color"] || settingFilter.swatchColor || settingFilter.options["Color"] || settingFilter.productOptions["Color"] || value[0].Code?.split('_')[1];
            switch (key) {
              case "Metal_Color":
                modelInitialData["ChangeRingColor"] = metalColor;
                if (!customisationAllowed) {
                  modelInitialData['ChangeCrownColor'] = metalColor;
                }
                break;
              case 'Crown_Metal_Color':
                modelInitialData['ChangeCrownColor'] = params[ringSettingParams[key]]?.split('_')[1] || metalColor;
                break;
              case 'Diamond_Shape':
                modelInitialData[key] = params[ringSettingParams[key]] || ring.options[key] || selectedDiamond[key] || settingFilter.options[key] || settingFilter.productOptions[key] || value[0].Code;
                break;
              case 'Side_Stones':
                modelInitialData[key] = params[ringSettingParams[key]] || ring.options[key] || value[0].Code;
                break;
              case 'Earring_Back': {
                  const earRingBackValue = params[ringSettingParams[key]] || ring.options[key] || value[0].Code;
                  window._earring_back = earRingBackValue;
                  modelInitialData[key] = earRingBackValue;
                  break;
              }
            }
            if (![ ...Object.keys(selectedDiamond), 'Metal_Color', 'Crown_Metal_Color' ].includes(key)) {
              const defaultValue =
                key === "Center_Diamond_Size"
                  ? params[ringSettingParams[key]] || ((isSettingPage ? (typeof selectedDiamondSize === "string" ? fitToAvailableSize(selectedDiamondSize, availableSizeCodes) : selectedDiamondSize) || value[0].Code : initialBuilderDiamondSize))
                  : key === "Diamond_Shape" ? params[ringSettingParams[key]] || (ring.options["Diamond_Shape"] || settingFilter.options["Diamond_Shape"] || settingFilter.productOptions["Diamond_Shape"] || value[0].Code)
                    : Object.keys(settingFilter.options).includes(key)
                      ? (key === 'Ring_Style')
                        ? params[ringSettingParams[key]] || value[0].Code
                        : params[ringSettingParams[key]] || ring.options[key] || settingFilter.options[key]
                      : (key === 'Diamond_Type' && Object.keys(settingFilter.options).includes('Center_Diamond_Type'))
                        ? settingFilter.options['Center_Diamond_Type']
                        : key === 'Diamond_Type' ? params[ringSettingParams[key]] || 'LGN' : params[ringSettingParams[key]] || value[0].Code;
              // modelInitialData[key] = defaultValue;
              return setRingOptions(key, defaultValue);
            } else {
              if (key === 'Crown_Metal_Color') {
                const specialCaseMetal = [ 'Jenny Packham' ].includes(Extra_Data.Label) ? '18' : undefined;
                const ringMetal = params[ringSettingParams.Metal_Color]?.split('_');
                const Crown = {
                  'Crown_Metal': params[ringSettingParams[key]]?.split('_')[0] || ringMetal?.[0] || specialCaseMetal || ring.options['Crown_Metal'] || settingFilter.options['Metal'] || settingFilter.productOptions['Metal'] || value[0].Code?.split('_')[0],
                  'Crown_Color': params[ringSettingParams[key]]?.split('_')[1] || ringMetal?.[1] || ring.options['Crown_Color'] || settingFilter.swatchColor || settingFilter.options['Color'] || settingFilter.productOptions['Color'] || value[0].Code?.split('_')[1]
                };
                Object.entries(Crown).forEach(([ key, value ]) => setRingOptions(key, value));
              }
              if (key === "Metal_Color") {
                const specialCaseMetal = [ "Jenny Packham" ].includes(Extra_Data.Label) ? '18' : undefined;
                const metalColor = {
                  "Metal": params[ringSettingParams[key]]?.split('_')[0] || specialCaseMetal || ring.options["Metal"] || settingFilter.options["Metal"] || settingFilter.productOptions["Metal"] || value[0].Code?.split('_')[0],
                  "Color": params[ringSettingParams[key]]?.split('_')[1] || ring.options["Color"] || settingFilter.swatchColor || settingFilter.options["Color"] || settingFilter.productOptions["Color"] || value[0].Code?.split('_')[1]
                }
                Object.entries(metalColor).forEach(([ key, value ]) => setRingOptions(key, value))
              }
            }
          }
        });
        const extraData = await getNoBands(Extra_Data, setRingExtraData, modelInitialData.Ring_Style, modelInitialData.Ring_Crown, modelInitialData.Ring_Side, modelInitialData.Diamond_Shape);
        const selectedDiamondOptions: { [key: string]: string } = {};
        const selectedOptions: string[] = [];
        if (Object.keys(selectedDiamond).length > 0 && !isSettingPage) {
          [ "Diamond_Shape", "Center_Diamond_Size" ].forEach(item => selectedOptions.push(item));
          Object.entries(selectedDiamond).filter(([ key, value ]) => selectedOptions.includes(key)).forEach(([ key, value ]) => {
            selectedDiamondOptions[key] = value;
          })
        }
        const selectedExclusionData: { [key: string]: string }[] = Exclusion_Matrix.filter((item: {
          [key: string]: string
        }) => {
          return Object.keys(selectedDiamondOptions).every(key => item[key] === selectedDiamondOptions[key])
        });
        const ringExclusionMatrix = getExclusionMatrixOptions(selectedOptions, selectedExclusionData, modelInitialData, newResult);
        if (!ringExclusionMatrix || Object.keys(ringExclusionMatrix).length <= 0) {
          setPendingEvents([]);
          setIframeLoadActionCount(() => 0);
          await optionsData({}, null, signal, {});
          return;
        }
        excludedOptions([ ...Object.values(ringExclusionMatrix).flat() ], modelInitialData, newResult, true, extraData && extraData.Bands ? extraData.Bands > 0 : false, Exclusion_Matrix, selectedDiamondOptions)
        /* A band in the url is a deliberate choice, so it is not overwritten by the default. */
        if ((!footer.isRedirectToEdit || (!(Object.keys(ring.options).length > 0) && !Object.keys(ring.options).includes('Wedding_Band'))) && !isStuds && !params[ringSettingParams.Wedding_Band]) {
          setRingOptions('Wedding_Band', 'No Band');
        }
      } else {
        const excludedOptions = Object.fromEntries(Object.entries(exclusionMatrixOption).map(([ key ]) => {
          const value = ring.exclusionOption.filter(item => newResult[key].map((v: {
            Code: string;
          }) => v.Code).includes(item));
          return [ key, value ]
        }))
        setExclusionMatrixOption(excludedOptions)
      }
      setOptionsData(newResult);
    } catch (e) {
      setOptionsFail(e);
    }
  }, [ isStuds, setIframeLoadActionCount, setPendingEvents, styleId, footer.isRedirectToEdit, setRingExtraData, setOptionsLoading, setOptionsFail, setOptionsData, fetch, setRingOptions, handle3DObjectView, settingFilter.options, settingFilter.productOptions, footer.isRedirectToEdit, setInitialOption ]);
  const handlePDPOptions = useCallback((key: string, value: string) => {
    setRingOptions(key, value);

    // const updatedUrl = updateURLKey( key, value);

    // window.history.replaceState({...window.history.state, updatedUrl}, '', updatedUrl);
  }, [ setRingOptions, ring.options ]);

  // const updateURLKey = ( key:string, newValue:string)=> {
  //   const urlObj = new URL(currentUrl);
  //   const hash = urlObj.hash.substring(1);
  //   const params = new URLSearchParams(hash);
  //   params.set(ringSettingParams[key], newValue);
  //   urlObj.hash = `#${params.toString()}`;
  //   return urlObj.toString();
  // };

  const updateURLKeys = (updates: Record<string, string | null>, url: string): string => {
    const urlObj = new URL(url);
    let hash = urlObj.hash.substring(1); // Remove leading '#'

    let basePath = '';
    if (hash.includes('/')) {
      basePath = hash.split('/')[0] + '/';
      hash = hash.replace(basePath, '');
    }

    let diamondIdSegment = '';
    const diamondMatch = hash.match(/\/diamondId=[^&]+/);
    const [ , searchParams ] = hash.split("?");
    if (diamondMatch) {
      const [ diamondId ] = diamondMatch[0]?.split("?");
      diamondIdSegment = diamondId;
      hash = hash.replace(diamondIdSegment, '');
    }
    if (searchParams) {
      hash = hash.replace(`?${searchParams}`, '');
    }
    const params = new URLSearchParams(hash);
    Object.entries(updates).forEach(([ key, newValue ]) => {
      const paramKey = ringSettingParams[key];
      if (paramKey) {
        /* null drops the param, for an option back at its default. Every other caller passes a
           string, so their behaviour is unchanged. */
        newValue === null ? params.delete(paramKey) : params.set(paramKey, newValue);
      }
    });

    urlObj.hash = `#${basePath}${params.toString()}${diamondIdSegment}${searchParams ? `?${searchParams}` : ""}`;

    return decodeURIComponent(urlObj.hash);
  };

  useEffect(() => {
    if (hasNormalisedMetalParamRef.current) return;

    const { Metal, Color, Crown_Metal, Crown_Color } = ring.options as { [key: string]: string };
    if (!Metal || !Color) return;

    const urlParams = extractParams(window.location.href);
    const isColourOnly = (value?: string) => typeof value === 'string' && value.startsWith('_');
    const metalIsPartial = isColourOnly(urlParams[ringSettingParams.Metal_Color]);
    const crownIsPartial = isColourOnly(urlParams[ringSettingParams.Crown_Metal_Color]);
    if (!metalIsPartial && !crownIsPartial) return;

    hasNormalisedMetalParamRef.current = true;
    const updates: Record<string, string> = {};
    if (metalIsPartial) updates.Metal_Color = `${Metal}_${Color}`;
    if (crownIsPartial) updates.Crown_Metal_Color = `${Crown_Metal || Metal}_${Crown_Color || Color}`;

    navigate(updateURLKeys(updates, window.location.href), { replace: true });
  }, [ ring.options.Metal, ring.options.Color, ring.options.Crown_Metal, ring.options.Crown_Color ]);

  /* The url only ever carried the options someone had changed. */
  const hasPublishedConfigRef = useRef(false);
  /* On an edit, the url's values win over the saved design. */
  const openedWithRingRef = useRef(Object.keys(ring.options).length > 0);
  useEffect(() => {
    hasPublishedConfigRef.current = false;
  }, [ styleId ]);
  useEffect(() => {
    /* Republish when the url has lost the configuration, e.g. editing from the review. */
    const urlHasConfig = !!extractParams(window.location.href)[ringSettingParams.Metal_Color];
    if (hasPublishedConfigRef.current && urlHasConfig) return;
    const options = ring.options as { [key: string]: string };
    if (!options.Metal || !options.Color) return;
    const config: Record<string, string> = {};
    [
      'Ring_Style', 'Diamond_Shape', 'Diamond_Type', 'Center_Diamond_Size',
      'Ring_Crown', 'Ring_Side', 'Ring_Size', 'Side_Stones', 'Diamond_Quality',
      'Earring_Back'
    ].forEach((key) => {
      if (options[key]) config[key] = options[key];
    });
    config.Metal_Color = `${options.Metal}_${options.Color}`;
    if (!isStuds && ring.extraData.customisation_allowed) {
      config.Crown_Metal_Color = `${options.Crown_Metal || options.Metal}_${options.Crown_Color || options.Color}`;
    }
    const band = options.Wedding_Band;
    if (!isStuds && (band === 'Single' || band === 'Double')) {
      config.Wedding_Band = band;
      if (options[`${band}_First_Metal_Band`]) config.First_Band_Metal = options[`${band}_First_Metal_Band`];
      if (band === 'Double' && options.Double_Second_Metal_Band) config.Second_Band_Metal = options.Double_Second_Metal_Band;
    }
    if (openedWithRingRef.current) {
      const inUrl = extractParams(window.location.href);
      Object.keys(config).forEach((key) => {
        if (inUrl[ringSettingParams[key]]) delete config[key];
      });
    }
    hasPublishedConfigRef.current = true;
    navigate(updateURLKeys(config, window.location.href), { replace: true });
  }, [ styleId, isStuds, ring.options, ring.extraData.customisation_allowed, showCrownMetal, currentUrl ]);
  useEffect(() => {
    const { Metal, Color, Crown_Metal, Crown_Color } = ring.options as { [key: string]: string };
    if (isStuds || !ring.extraData.customisation_allowed || !Metal || !Color) return;
    if (extractParams(window.location.href)[ringSettingParams.Crown_Metal_Color]) return;
    navigate(updateURLKeys({
      Crown_Metal_Color: `${Crown_Metal || Metal}_${Crown_Color || Color}`
    }, window.location.href), { replace: true });
  }, [ isStuds, ring.extraData.customisation_allowed, ring.options.Metal, ring.options.Color, ring.options.Crown_Metal, ring.options.Crown_Color ]);

  const getExclusionMatrixOptions = (selectedOptions: string[], selectedExclusionData: {
    [key: string]: string
  }[], ringOptions: { [key: string]: string }, allOptionsData: any) => {
    let wrongOptionSelected = false;
    const ringExclusionMatrix: { [key: string]: string[] } = {};
    for (const option of Object.keys(exclusionMatrixOption)) {
      if (!selectedOptions.includes(option)) {
        const otherExclusionOption = Object.keys(exclusionMatrixOption)
          .filter(item => !selectedOptions.includes(item))
          .filter(item => item !== option);
        const filteredData = selectedExclusionData.filter(data =>
          otherExclusionOption.every(k => data[k] === ringOptions[k])
        );
        const excludedCodes = new Set(filteredData.map((data) => data[option]));
        const availableCodes: string[] = (allOptionsData[option] || [])
          .map((entry: { Code: string }) => entry.Code);
        const everyOptionExcluded = availableCodes.length > 0
          && availableCodes.every((code) => excludedCodes.has(code));
        const rowCountMatchesOptions = filteredData.length > 0
          && filteredData.length === availableCodes.length;
        if (everyOptionExcluded || rowCountMatchesOptions) {
          const findIndex = Object.keys(exclusionMatrixOption).findIndex(key => key === option);
          const key = Object.keys(exclusionMatrixOption)[findIndex + 1];

          const nextOptionFilteredData = selectedExclusionData
            .filter(data =>
              Object.keys(exclusionMatrixOption)
                .filter(option => key !== option)
                .every(k => data[k] === ringOptions[k])
            )
            .map(option => option[key]);
          const command = urlData?.command;
          const nextCode: string | undefined = (allOptionsData[key] || []).filter(
            (data: { Code: string }) => !nextOptionFilteredData.includes(data.Code)
          )[0]?.Code;
          if (nextCode && nextCode !== ringOptions[key]) {
            if (isSettingPage || command === CONSTANTS.SETTING) {
              if (key && !Ring_Attributes.includes(option)) {
                ringOptions[key] = nextCode;
                setRingOptions(key, nextCode);
                return getExclusionMatrixOptions(selectedOptions, selectedExclusionData, {
                  ...ringOptions,
                  [key]: nextCode
                }, allOptionsData);
              }
            } else {
              return getExclusionMatrixOptions(selectedOptions, selectedExclusionData, {
                ...ringOptions,
                [key]: nextCode
              }, allOptionsData);
            }
          }
        }
        if (filteredData.map(data => data[option]).includes(ringOptions[option])) {
          const getValue = Object.entries(allOptionsData)
            .filter(([ key ]) => (isSettingPage ? !Ring_Attributes.includes(option) : key))
            .map(([ ringKey, ringValue ]) => {
              if (ringKey === option) return ringValue;
            })
            .filter(item => item);

          if (filteredData.length === getValue.length) {
            wrongOptionSelected = true;
          }

          const firstValue = getValue
            .flat()
            .find(item => !filteredData.map(data => data[option]).includes((item as { Code: string }).Code));

          if (firstValue) {
            ringOptions[option] = (firstValue as { Code: string }).Code;
            setRingOptions(option, (firstValue as { Code: string }).Code);
          }
        }

        ringExclusionMatrix[option] = filteredData.map(data => data[option]);
      } else {
        ringExclusionMatrix[option] = [];
      }
    }
    if (wrongOptionSelected) {
      setInitialOption();
      const selectedStyleId = styleId || 'RB001';
      (screenManager as any).changeScreen({
        viewName:     selectedStyleId.includes('RB') ? 'dyo' : 'setting',
        styleId:      selectedStyleId,
        searchParams: getBuildSearchParams(window.location)
      });
      return {};
    }
    setExclusionMatrixOption(ringExclusionMatrix);
    return ringExclusionMatrix;
  }
  const selectedData = useCallback(async (diamondDetail: {
    [key: string]: string
  }, carat: string, signal: AbortSignal, params: { [key: string]: string }) => {
    const result = await getDiamondCode(diamondDetail, setSelectedDiamondLoading, setSelectedDiamondFail);
    if (result) {
      /* Fit here, not only inside optionsData: on edit this runs after the options are already
         loaded, so writing the raw carat-derived size would replace a good size with one the
         style does not build until the optionsData round-trip caught up. */
      const centerDiamondSize = fitToAvailableSize(
        findNearestValue(+carat),
        (ring.optionsData?.Center_Diamond_Size as { Code: string }[] | undefined)?.map(option => option.Code)
      );
      setSelectedDiamondData({ ...result, Center_Diamond_Size: centerDiamondSize as string });
      await optionsData({
        ...result,
        Center_Diamond_Size: centerDiamondSize as string
      }, diamondDetail.shape, signal, params);
    }
  }, [ urlData, URLSearchParams, setSelectedDiamondLoading, setSelectedDiamondData, setSelectedDiamondFail, optionsData, fetch, ring.optionsData ]);
  const DetailsData = useCallback(async (id: string, signal: AbortSignal, params: { [key: string]: string }) => {
    setDiamondDetailsLoading();
    try {
      const response = await fetch(`${process.env.REACT_APP_API_KEY}/?id='${id}'`);
      if (!response.ok) {
        setDiamondDetailsFail(new Error(`HTTP error! Status: ${response.status}`));
      }
      const result: TableData = await response.json();
      if (!result) {
        const selectedStyleId = styleId || 'RB001';
        (screenManager as any).changeScreen({
          viewName: selectedStyleId.includes('RB') ? 'dyo' : 'setting',
          styleId:  selectedStyleId,
          params:       params,
          searchParams: getBuildSearchParams(window.location)
        });
        setDiamondDetailsSuccess({});
        await optionsData({}, null, signal, params);
        return;
      }
      Object.keys(propertyMappings).forEach((property: string) => {
        result[property] = propertyMappings[property][result[property] as number - 1];
      });
      const updatedResult: TableData = {
        ...result,
        source: result.source === 'GNU' ? source[0] : source[1],
        // diamond_price: result.diamond_price !== null ? `${result.diamond_price}` : '-'
      }
      setDiamondDetailsSuccess(updatedResult);
      setIsShowFooter(true);
      if (updatedResult) {
        const { shape, source, carat } = updatedResult;
        const details = { shape: shape as string, type: source as string };
        await selectedData(details, carat as string, signal, params);
      }
    } catch (e) {
      setDiamondDetailsFail(e);
    }
  }, [ diamondId, setDiamondDetailsSuccess, setDiamondDetailsLoading, setDiamondDetailsFail, selectedData, fetch ]);

  const [ excludeAction, setExcludeAction ] = useState(false);
  useEffect(() => {
    if (excludeAction && Object.keys(ring.options).length > 0) {
      const {
        Center_Diamond_Size, Diamond_Shape, Ring_Crown, Ring_Side, Ring_Style, Wedding_Band
      } = ring.options;
      if (optionsKey && optionsKey !== "Ring_Side" && !isStuds) {
        sendMessage('LoadHead', `${styleId}/${styleId?.includes('RB') ? `${Ring_Style}${Ring_Crown}` : Ring_Crown}/${Diamond_Shape}/${Center_Diamond_Size}${styleId?.includes('RB') ? "" : `/${Ring_Side}`}/${getThreeDFileName("head", urlData.command)}`);
        setIframeLoadActionCount(count => count + 1);
      }
      sendMessage('LoadShank', `${styleId}/${styleId?.includes('RB') ? `${Ring_Style}${Ring_Crown}` : Ring_Crown}/${Diamond_Shape}/${Center_Diamond_Size}/${Ring_Side}/${getThreeDFileName("shank", urlData.command)}`);
      setIframeLoadActionCount(count => count + 1);
      if (Wedding_Band && Wedding_Band !== 'No Band' && ring.extraData.Bands !== 0) {
        sendMessage('LoadBand', `${styleId}/${styleId?.includes('RB') ? `${Ring_Style}${Ring_Crown}` : Ring_Crown}/${Diamond_Shape}/${Center_Diamond_Size}/${Ring_Side}/${getThreeDFileName("bands", urlData.command)}`);
        setIframeLoadActionCount(count => count + 1);
      }
      bands3DModel();
      setExcludeAction(false);
    }
  }, [ excludeAction, ring.options ])
  const handleInitialModel = useCallback((options: { [key: string]: string }, isLoadBands: boolean) => {
    if (!header.resetPath) {
      if (isStuds) {
        handle3DObjectView('LoadShank', `${styleId}/${options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}/${options.Ring_Side}/${getThreeDFileName("shank", urlData.command)}`)
        handle3DObjectView('LoadStudBack',"")
        handle3DObjectView('EarringBack', options.Earring_Back)
        setIframeLoadActionCount(count => count + 2);
      } else {
        handle3DObjectView('LoadHead', `${styleId}/${styleId?.includes('RB') ? `${options.Ring_Style}${options.Ring_Crown}` : options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}${styleId?.includes('RB') ? "" : `/${options.Ring_Side}`}/${getThreeDFileName("head", urlData.command)}`);
        handle3DObjectView('LoadShank', `${styleId}/${styleId?.includes('RB') ? `${options.Ring_Style}${options.Ring_Crown}` : options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}/${options.Ring_Side}/${getThreeDFileName("shank", urlData.command)}`);
        setIframeLoadActionCount(count => count + 2);
        if (isLoadBands) {
          handle3DObjectView('LoadBand', `${styleId}/${styleId?.includes('RB') ? `${options.Ring_Style}${options.Ring_Crown}` : options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}/${options.Ring_Side}/${getThreeDFileName("bands", urlData.command)}`);
          setIframeLoadActionCount(count => count + 1);
        }
      }
      handle3DObjectView('ChangeRingColor', options.ChangeRingColor)
      handle3DObjectView('ChangeCrownColor', options.ChangeCrownColor);
      if (options.Side_Stones) {
        handle3DObjectView('ChangeSideStone', options.Side_Stones);
      }
      const params = extractParams(window.location.href);
      const band = params[ringSettingParams.Wedding_Band];
      if (!isStuds && isLoadBands && [ 'Single', 'Double' ].includes(band)) {
        handle3DObjectView('LeftBand', true);
        handle3DObjectView('ChangeLeftBandColor', params[ringSettingParams.First_Band_Metal]?.split('_')[1] || options.ChangeRingColor);
        handle3DObjectView('RightBand', band === 'Double');
        if (band === 'Double') {
          handle3DObjectView('ChangeRightBandColor', params[ringSettingParams.Second_Band_Metal]?.split('_')[1] || options.ChangeRingColor);
        }
      }
    } else {
      const pendingValues = {
        ChangeRingColor: options.ChangeRingColor,
        ChangeCrownColor: options.ChangeCrownColor,
        LeftBand:        false,
        RightBand:       false,
        ...(options.Side_Stones && { ChangeSideStone: options.Side_Stones }),
        ...(options.Earring_Back && {'EarringBack' : options.Earring_Back}),
      }
      const pendingRingSideEvents: {
        [key: string]: boolean | string
      }[] = Object.entries(pendingValues).map(([ key, value ]) => {
        return { action: key, value }
      })
      setPendingEvents(pendingRingSideEvents);
      sendMessage('LoadHead', `RB001/${options.Ring_Style}${options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}/${getThreeDFileName("head", urlData.command)}`);
      sendMessage('LoadShank', `RB001/${options.Ring_Style}${options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}/${options.Ring_Side}/${getThreeDFileName("shank", urlData.command)}`);
      setIframeLoadActionCount(count => count + 2);
      if (isLoadBands) {
        sendMessage('LoadBand', `RB001/${options.Ring_Style}${options.Ring_Crown}/${options.Diamond_Shape}/${options.Center_Diamond_Size}/${options.Ring_Side}/${getThreeDFileName("bands", urlData.command)}`);
        setIframeLoadActionCount(count => count + 1);
      }
    }
  }, [ isStuds, setPendingEvents, ring.options, styleId, setIframeLoadActionCount, handle3DObjectView, header.resetPath, sendMessage ]);


  const excludedOptions = useCallback((
    isNotShowOptions: string[],
    selectedOptions: { [key: string]: string },
    allOptionsData: any,
    initialLoad = false,
    isLoadBands: boolean,
    exclusionMatrix: { [key: string]: string }[],
    selectedDiamondOptions: { [key: string]: string } = {}) => {
    setExclusionOption(isNotShowOptions);
    setIsDisabledOption(false);
    if (isNotShowOptions.length <= 0) {
      if (initialLoad) {
        handleInitialModel(selectedOptions, isLoadBands);
      } else {
        setExcludeAction(true);
      }
      return;
    }
    if (initialLoad) {
      return handleInitialModel(selectedOptions, isLoadBands);
    }
    setExcludeAction(true);
  }, [ styleId, setExclusionOption, setIsDisabledOption, ring.options, ring.optionsData, handlePDPOptions, setExcludeAction, isStuds ]);
  const [ exclusionMatrixOption, setExclusionMatrixOption ] = useState<{
    [key: string]: string[]
  }>(initialExclusionKey(isSettingPage));
  const [ optionsKey, setOptionsKey ] = useState('');
  const handleWeddingBand = (number: number, label: string) => {
    changeBackClick(false);
    setShowError(false);
    isEditableRingOptions.current = false;
    setBandTabIndex(number);
    setRedirectEditPage(false);
    setRingOptions("Wedding_Band", label);
    [ "Single_First_Band", "Double_First_Band", "Double_Second_Band" ]
      .filter((band, index) => number === 0 || (number === 1 && index > 0) || (number === 2 && index < 1))
      .forEach(band => setRemoveRingOption(band));
    [ "Single_First_Metal_Band", "Double_First_Metal_Band", "Double_Second_Metal_Band" ]
      .filter((band, index) => number === 0 || (number === 1 && index > 0) || (number === 2 && index < 1))
      .forEach(band => setRemoveRingOption(band));
    [ "First_Band_Engraving", "Second_Band_Engraving" ]
      .filter((band, index) => number === 0 || (number === 1 && index > 0) || (number === 2 && index > 1))
      .forEach(band => setRemoveRingOption(band));
    Array.from(Array(number)).map((tabIndex, index) => {
      setRingOptions(`${label}_${index + 1 === 1 ? 'First' : 'Second'}_Band`, ring.options["Color"]);
      setRingOptions(`${label}_${index + 1 === 1 ? 'First' : 'Second'}_Metal_Band`, `${ring.options["Metal"]}_${ring.options["Color"]}`);
    })
    /* The band is the one option that never reached the url, so a shared link always rebuilt
       the ring without it. No Band is the default, so it drops the param rather than spelling
       it out. The metals go with it - a band restored without one came back in the ring's own
       colour rather than the one that was picked. */
    const bandMetal = `${ring.options["Metal"]}_${ring.options["Color"]}`;
    navigate(updateURLKeys({
      Wedding_Band:      label === weddingBand[0] ? null : label,
      First_Band_Metal:  number > 0 ? bandMetal : null,
      Second_Band_Metal: number > 1 ? bandMetal : null,
    }, window.location.href), { replace: true });
  }

  /* Lets the band's own metal picker keep the url in step, the way the band itself does. */
  const updateBandMetalUrl = (index: number, code: string) => {
    navigate(updateURLKeys({
      [index === 0 ? 'First_Band_Metal' : 'Second_Band_Metal']: code,
    }, window.location.href), { replace: true });
  };
  const handleAllOptions = useCallback(async (key: string, value: any) => {
    const {
      Wedding_Band,
      Single_First_Metal_Band,
      Double_First_Metal_Band,
      Double_Second_Metal_Band,
      Crown_Metal,
      Crown_Color,
      Earring_Back
    } = ring.options;
    const customisationAllowed = ring.extraData.customisation_allowed;
    changeBackClick(false);
    setShowError(false);
    let options;
    const obj: Record<string, string | null> = {
      [key]: value.Code
    };
    if ([ 'Metal_Color' ].includes(key)) {
      const [ metal, color ] = value.Code?.split('_') || [];
      const shouldSyncCrown = customisationAllowed && !showCrownMetal;
      const newCrownMetal = shouldSyncCrown
        ? metal
        : (metal === 'PT') ? (Crown_Color === 'WG' ? 'PT' : '18') : metal !== 'PT' && Crown_Metal !== 'PT' ? metal : Crown_Metal;
      const newCrownColor = shouldSyncCrown ? color : Crown_Color;
      options = {
        'Metal': metal,
        'Color': color,
        ...(customisationAllowed && { 'Crown_Metal': newCrownMetal, 'Crown_Color': newCrownColor }),
        /* 'Crown_Metal': (metal === 'PT')
                          ? (Crown_Color === 'WG' ? 'PT' : '18')
                          : metal !== 'PT' && Crown_Metal !== 'PT'
             ? metal
             : Crown_Metal*/
        ...((isStuds && metal === "PT" && Earring_Back && Earring_Back?.toLowerCase() === "GRD"?.toLowerCase()) && { Earring_Back: ring.optionsData?.["Earring_Back"][0]?.Code })
        // "Crown_Color": color
      };
      Object.entries(options).forEach(([ key, value ]) => handlePDPOptions(key, value));
      if (isStuds && metal === "PT" && Earring_Back && Earring_Back?.toLowerCase() === "GRD"?.toLowerCase()) {
        obj["Earring_Back"] = ring.optionsData?.["Earring_Back"][0]?.Code;
      }
      if (customisationAllowed) {
        obj["Crown_Metal_Color"] = `${newCrownMetal}_${newCrownColor}`;
      }
    } else if ('Crown_Metal_Color'.includes(key)) {
      const crown = {
        'Crown_Metal': value.Code?.split('_')[0],
        'Crown_Color': value.Code?.split('_')[1]
      };
      Object.entries(crown).forEach(([ key, value ]) => handlePDPOptions(key, value));
    } else {
      handlePDPOptions(key, value.Code);
    }
    if (![ 'Crown_Metal_Color', 'Metal_Color', 'Diamond_Type', 'Ring_Size', "Side_Stones", "Diamond_Quality", "Earring_Back" ].includes(key)) {
      setIsDisabledOption(true);
      const extraData = await getNoBands(ring.extraData, setRingExtraData, key === "Ring_Style" ? value.Code : ring.options.Ring_Style, (key === "Ring_Crown") ? value.Code : ring.options.Ring_Crown, (key === "Ring_Side") ? value.Code : ring.options.Ring_Side, (key === "Diamond_Shape") ? value.Code : ring.options.Diamond_Shape);
      if (extraData?.Bands === 0) {
        handleWeddingBand(0, 'No Band');
      }
      setOptionsKey(key);
      const ringExclusionMatrix = getExclusionOptions(exclusionMatrix, key, value.Code, exclusionMatrixOption, ring.options)
      setExclusionMatrixOption({ ...ringExclusionMatrix, [key]: exclusionMatrixOption[key] });
      excludedOptions(
        [ ...Object.values(ringExclusionMatrix).flat(), ...(exclusionMatrixOption[key]?.length ? exclusionMatrixOption[key] : []) ],
        { ...ring.options, [key]: value.Code },
        ring.optionsData,
        false,
        ring.extraData.Bands !== 0,
        exclusionMatrix
      );
    } else {
      switch (key) {
        case 'Crown_Metal_Color':
          const [ Crown_Metal, Crown_Color ] = value.Code?.split('_');
          sendMessage('ChangeCrownColor', Crown_Color);
          break;
        case "Side_Stones":
          sendMessage('ChangeSideStone', value.Code);
          break;
        case "Earring_Back":
            window._earring_back = value.Code;
            sendMessage('EarringBack', value.Code);
          break;
        case 'Metal_Color':
          const [ metal, color ] = value.Code?.split('_');
          if (Wedding_Band && Wedding_Band !== "No Band") {
            const [ firstBandMetal, firstBandColor ] = (Single_First_Metal_Band || Double_First_Metal_Band)?.split('_');
            if (metal !== firstBandMetal) {
              sendMessage('ChangeLeftBandColor', firstBandColor);
              handlePDPOptions(`${Wedding_Band}_First_Metal_Band`, `${![ "WG" ].includes(firstBandColor) && metal === 'PT' ? '18' : metal}_${firstBandColor}`);
              handlePDPOptions(`${Wedding_Band}_First_Band`, `${firstBandColor}`);
            }
            if (Wedding_Band === "Double") {
              const [ secondBandMetal, secondBandColor ] = Double_Second_Metal_Band?.split('_');
              if (metal !== secondBandMetal) {
                sendMessage('ChangeRightBandColor', secondBandColor);
                handlePDPOptions(`${Wedding_Band}_Second_Metal_Band`, `${![ "WG" ].includes(secondBandColor) && metal === 'PT' ? '18' : metal}_${secondBandColor}`);
                handlePDPOptions(`${Wedding_Band}_Second_Band`, `${secondBandColor}`);
              }
            }
          }
          if (isStuds && metal === "PT" && Earring_Back && Earring_Back?.toLowerCase() === "GRD"?.toLowerCase()) {
            sendMessage('EarringBack', ring.optionsData?.["Earring_Back"][0]?.Code);
          }
          sendMessage('ChangeRingColor', color);
          if (!customisationAllowed || !showCrownMetal) {
            sendMessage('ChangeCrownColor', color);
          }
          break;
        default:
          break;
      }
    }
    // const params = extractParams(currentUrl);
    // if(Object.keys(params).includes(ringSettingParams[key])) {
    const updatedUrl = updateURLKeys(obj, currentUrl);
    navigate(updatedUrl, { replace: true });
    // }
  }, [ ring.optionsData, isStuds, ringSettingParams, currentUrl, extractParams, ring.extraData.customisation_allowed, showCrownMetal, styleId, setExclusionMatrix, exclusionMatrixData, setIsDisabledOption, changeBackClick, getExclusionOptions, getNoBands, setOptionsKey, handlePDPOptions, ring.options, ring.optionsData, setShowError, ring.extraData, sendMessage, setExclusionMatrixOption, excludedOptions, exclusionMatrix, exclusionMatrixOption ]);
  const bands3DModel = useCallback(() => {
    const {
      Color,
      Crown_Color,
      Wedding_Band,
      Single_First_Metal_Band,
      Double_First_Metal_Band,
      Double_Second_Metal_Band,
      Side_Stones,
      Earring_Back
    } = ring.options;
    const { customisation_allowed } = ring.extraData;
    const pendingValues: { [key: string]: boolean | string } = {};
    if (Color) pendingValues['ChangeRingColor'] = Color;
    if (Side_Stones) pendingValues['ChangeSideStone'] = Side_Stones;
    if (Color) pendingValues['ChangeCrownColor'] = customisation_allowed ? Crown_Color : Color;
    if(Wedding_Band){
      if (Wedding_Band !== 'No Band') {
        if (Wedding_Band === "Single" || Wedding_Band === "Double") {
          pendingValues['ChangeLeftBandColor'] = Wedding_Band === "Single" ? Single_First_Metal_Band?.split('_')[1] : Double_First_Metal_Band?.split('_')[1];
          pendingValues['LeftBand'] = true;
          pendingValues['RightBand'] = false;
          if (Wedding_Band === "Double") {
            pendingValues['ChangeRightBandColor'] = Double_Second_Metal_Band?.split('_')[1];
            pendingValues['RightBand'] = true;
          }
        }
      } else {
        [ 'LeftBand', 'RightBand' ].forEach(band => pendingValues[band] = false);
      }
    }
    if (Earring_Back) pendingValues['EarringBack'] = Earring_Back;
    const pendingRingSideEvents: {
      [key: string]: boolean | string
    }[] = Object.entries(pendingValues).map(([ key, value ]) => {
      return { action: key, value }
    })
    setPendingEvents(pendingRingSideEvents)
    return true;
  }, [ ring.extraData, ring.options, setPendingEvents ])

  function sendMessage(action: string, value: string | boolean) {
    window.postMessage({ action, value });
  }

  const getExcusionMatrix = useCallback(async ()=>{
    const Exclusion_Matrix = await exclusionMatrixData(styleId);
    setExclusionMatrix(Exclusion_Matrix);
  },[exclusionMatrixData,styleId,setExclusionMatrix])

  const getExclusionData = async () => {
    const Exclusion_Matrix = await exclusionMatrixData(styleId);
    setExclusionMatrix(Exclusion_Matrix);
  }
  const isEditableRingOptions = useRef(false);
  const abortController = new AbortController();
  useEffect(() => {
    const signal = abortController.signal;
    //edit code
    const styleId = urlData?.params?.styleId;
    if (!styleId || !urlData?.command) return;
    if (lastProcessedCommand.current === urlData.command) return;
    lastProcessedCommand.current = urlData.command;
    getExclusionData();
    setStyleID(styleId);
    setIsFirstTimeHandShake(false);
    setJourney(urlData?.command);
    const params = extractParams(currentUrl);
    if (Object.keys(ring.options).length > 0) {
      isEditableRingOptions.current = true;
      const mappedEntries: [ string, any ][] = Object.entries(params).flatMap(
        ([ paramKey, paramValue ]) => {
          const originalKey = Object.keys(ringSettingParams).find(
            (k) => ringSettingParams[k] === paramKey
          );
          if (!originalKey || !paramValue) return [];

          if ([ "Metal_Color", "Crown_Metal_Color" ].includes(originalKey)) {
            const [ metalValue, colorValue ] = paramValue?.split('_');
            /* The crown sets its own colour, not the ring's. */
            const isCrown = originalKey === "Crown_Metal_Color";
            const metalKey = isCrown ? "Crown_Metal" : "Metal";
            const colorKey = isCrown ? "Crown_Color" : "Color";

            const entries: [ string, any ][] = [];

            if (metalValue) {
              setRingOptions(metalKey, metalValue);
              entries.push([ metalKey, metalValue ]);
            }

            if (colorValue) {
              setRingOptions(colorKey, colorValue);
              entries.push([ colorKey, colorValue ]);
            }
            return entries;
          }

          setRingOptions(originalKey, paramValue);
          return [ [ originalKey, paramValue ] ];
        }
      );

      const paramsOptions = Object.fromEntries(mappedEntries);
      const {
        Ring_Style,
        Ring_Crown,
        Diamond_Shape,
        Center_Diamond_Size,
        Side_Stones,
        Ring_Side,
        Wedding_Band,
        Single_First_Metal_Band,
        Double_First_Metal_Band,
        Double_Second_Metal_Band,
        First_Band_Engraving,
        Second_Band_Engraving,
        Engraving,
        Earring_Back,
        Crown_Color,
        Color
      } = { ...ring.options, ...paramsOptions }
      console.log(Side_Stones, "Side_Stones")
      window._earring_back = Earring_Back;
      const customisationAllowed = ring.extraData.customisation_allowed;
      const styleIdPrefix = styleId && styleId.includes('RB') ? `${Ring_Style}${Ring_Crown}` : Ring_Crown;
      const bandTabIndex = Wedding_Band === 'Single' ? 1 : Wedding_Band === 'Double' ? 2 : 0;
      const bandColor = Wedding_Band === 'Single' ? Single_First_Metal_Band : Wedding_Band === 'Double' ? Double_First_Metal_Band : null;
      const pendingValues: { [key: string]: boolean | string } = {
        'LoadShank':       `${styleId}/${styleIdPrefix}/${Diamond_Shape}/${Center_Diamond_Size}/${Ring_Side}/${getThreeDFileName("shank", urlData.command)}`,
        'ChangeRingColor': Color,
        'ChangeCrownColor': customisationAllowed ? Crown_Color : Color
      };
      if(isStuds){
        pendingValues['LoadStudBack'] = "";
        setIframeLoadActionCount(count => count + 1);
      }
      if (!isStuds) {
        pendingValues['LoadHead'] = `${styleId}/${styleIdPrefix}/${Diamond_Shape}/${Center_Diamond_Size}${styleId.includes('RB') ? "" : `/${Ring_Side}`}/${getThreeDFileName("head", urlData.command)}`;
        setIframeLoadActionCount(count => count + 1);
      }
      if (ring.extraData.Bands !== 0 && !isStuds) {
        pendingValues['LoadBand'] = `${styleId}/${styleIdPrefix}/${Diamond_Shape}/${Center_Diamond_Size}/${Ring_Side}/${getThreeDFileName("bands", urlData.command)}`;
        setIframeLoadActionCount(count => count + 1);
      }
      if (Wedding_Band !== 'No Band' && Wedding_Band) {
        if (Wedding_Band === "Single" || Wedding_Band === "Double") {
          setBandTabIndex(bandTabIndex);
          pendingValues['ChangeLeftBandColor'] = bandColor?.split('_')[1] as string;
          pendingValues['LeftBand'] = true;
          pendingValues['RightBand'] = false;
          if (Wedding_Band === "Double") {
            setBandTabIndex(bandTabIndex);
            pendingValues['ChangeRightBandColor'] = Double_Second_Metal_Band?.split('_')[1];
            pendingValues['RightBand'] = true;
          }
        }
      }

      if (Engraving) pendingValues['ShankEngraving'] = Engraving;
      if (First_Band_Engraving) pendingValues['LeftEngraving'] = First_Band_Engraving;
      if (Second_Band_Engraving) pendingValues['RightEngraving'] = Second_Band_Engraving;
      if (Side_Stones) pendingValues['ChangeSideStone'] = Side_Stones;
      if (Earring_Back) pendingValues['EarringBack'] = Earring_Back;

      setIframeLoadActionCount(count => count + 1);
      const pendingRingSideEvents = Object.entries(pendingValues).map(([ action, value ]) => ({ action, value }));
      setPendingEvents(pendingRingSideEvents);
      getExcusionMatrix();
      if (!(rpid && uuid) && builder_mode !== CONSTANTS.EDIT) {
        return;
      }
    }

    if (Object.keys(diamond.details).length > 0) {
      const { shape, source, carat } = diamond.details;
      const details = { shape: shape as string, type: source as string };
      selectedData(details, carat as string, signal, params);
    } else if (diamondId) {
      DetailsData(diamondId, signal, params);
    } else {
      optionsData({}, null, signal, params);
    }
    return () => {
      if (process.env.NODE_ENV === "production") {
        abortController.abort();
      }
    };
  }, [ urlData?.command ]);

  useEffect(() => {
    if (!hasEffectRun.current) {
      TooltipDataFetch(setTooltipDataLoading, SetTooltipDataSuccess, SetTooltipDataError);
    }
    return () => {
      hasEffectRun.current = true;
    }
  }, [])

  useLayoutEffect(() => {
    const { Center_Diamond_Size, Diamond_Shape, Ring_Crown, Ring_Side, Ring_Style, Wedding_Band } = ring.options || {};
    const messages = [ "LeftBand", "RightBand", "LeftEngraving", "RightEngraving" ];
    if (Wedding_Band && !isEditableRingOptions.current && !header.backClick) {
      if (Wedding_Band && Wedding_Band !== 'No Band' && !footer.isRedirectToEdit && ring.extraData.Bands !== 0) {
        bands3DModel();
        setIframeLoadActionCount(count => count + 1);
        sendMessage('LoadBand', `${styleId}/${styleId?.includes('RB') ? `${Ring_Style}${Ring_Crown}` : Ring_Crown}/${Diamond_Shape}/${Center_Diamond_Size}/${Ring_Side}/${getThreeDFileName("bands", urlData.command)}`);
        if (Wedding_Band === 'Single') {
          window.postMessage({ action: "RightEngraving", value: '' });
        }
      } else {
        messages.forEach(message => window.postMessage({
          action: message,
          value:  [ "LeftEngraving", "RightEngraving" ].includes(message) ? '' : false
        }));
        window.postMessage({
          action: 'SwitchCameraView'
        })
      }
      changeBackClick(false);
    }
  }, [ ring.options["Wedding_Band"] ]);

  const validate = useRef(false);

  useEffect(() => {
    if (fieldValidation.length > 0) {
      handleCheckValidation();
    }
  }, [ ring.options ])

  const handleCheckValidation = useCallback(() => {
    const fieldObject = Object.keys(ring.optionsData);
    setFieldValidation([]);
    fieldObject.forEach((field: string) => {
      const checkData = !Object.keys(ring.options).includes([ 'Metal_Color' ].includes(field) ? 'Metal' : [ 'Crown_Metal_Color' ].includes(field) ? 'Crown_Metal' : field);
      if (checkData) {
        validate.current = true;
        setFieldValidation((prev) => {
          return [ ...prev, field ];
        })
      }
    })
  }, [ setFieldValidation, ring.optionsData, ring.options ])
  useEffect(() => {
    if (showError) {
      document.querySelector(`button[name=${fieldValidation[0]}]`)?.scrollIntoView({
        behavior: 'smooth', block: 'center', inline: 'start',
      })
    }
  }, [ fieldValidation ])
  const handleSelectSetting = useCallback(() => {
    setShowError(true);
    handleCheckValidation();
    if (validate.current) {
      validate.current = false;
      return;
    }
    /* window.postMessage({action: "DownloadSnapshot"});
     set3DImageLoading();*/
    setIsShowFooter(true);
    if (screenManager && (screenManager as any).changeScreen) {
      (screenManager as any).props.setStateManagerData('selectedSetting', ring.options,);

      if (Object.keys(diamond.details).length > 0) {
        (screenManager as any).props.setStateManagerData('cost', (diamond.details.b2c_price as number) + +ringPrice ,);

        // await storeDesignData();

        return setFooterToggle();
      }
      if (ring.options) {
        const {
          Diamond_Type,
          Diamond_Shape,
          Center_Diamond_Size,
        } = ring.options;
        const findNearestValue = isSettingPage ? startWithSettingValue : buildYourOwnValue;
        const multiplier = findNearestValue[Center_Diamond_Size] === 0.75 ? 0.07 : [ 1, 2, 3 ].includes(findNearestValue[Center_Diamond_Size]) ? 0.05 : 0.13;
        const selectedDiamondOptions: { [key: string]: string | boolean | string[] } = {
          source: Diamond_Type,
          shape: Diamond_Shape,
          carat: `${
            (Number(findNearestValue[Center_Diamond_Size]) -
              Number(findNearestValue[Center_Diamond_Size]) * multiplier).toFixed(2)
          }-${
            (Number(findNearestValue[Center_Diamond_Size]) +
              Number(findNearestValue[Center_Diamond_Size]) * 0.2).toFixed(2)
            // Number(findNearestValue[Center_Diamond_Size]) * (findNearestValue[Center_Diamond_Size] === 3 ? 1 : 0.1)
          }`,
        };
        if ([ "Jenny Packham", "Reve" ].includes(ring.extraData.Label)) {
          // selectedDiamondOptions['lab'] = ["GCAL"];
          ring.extraData.Label === 'Reve' && (selectedDiamondOptions['sustainable'] = true)
        }
        setAfterRingOptions(selectedDiamondOptions as { [key: string]: string | string[] });
      }
      changeBackClick(false);
      setSettingTabIconTrue();
      // navigate('/select-diamond');
      (screenManager as any).changeScreen({
        viewName: 'diamond',
        id:       null,
        searchParams: getBuildSearchParams(window.location)
      });
    }
    /*if(Object.keys(diamond.details).length > 0){
            return setFooterToggle();
        }
        if(ring.options){
            const {Diamond_Type,Diamond_Shape,Center_Diamond_Size} = ring.options;
            const selectedDiamondOptions = {
                source: Diamond_Type,
                shape: [Diamond_Shape],
                carat: `${Number(centerDiamondSizeValue[Center_Diamond_Size]) - Number(centerDiamondSizeValue[Center_Diamond_Size])*0.1}-${Number(centerDiamondSizeValue[Center_Diamond_Size]) + Number(centerDiamondSizeValue[Center_Diamond_Size])*0.1}`
            };
            setAfterRingOptions(selectedDiamondOptions)
        }
        setSettingTabIconTrue();
        navigate('/select-diamond');
    }}*/
  }, [ screenManager, setFooterToggle, setSettingTabIconTrue, setAfterRingOptions, setShowError, handleCheckValidation, setIsShowFooter, ring.options, diamond.details, ringPrice, styleId, startWithSettingValue, buildYourOwnValue, changeBackClick ]);

  // temp code
  const actionButtonRef = useRef<any>();
  useEffect(() => {
    if (actionButtonRef.current) {
      (actionButtonRef.current as any).addEventListener('3DEvent', (e: any) => {
        // console.log('react caught custom event directly on component', e.detail);
        window.postMessage(e.detail);
      });
    }
  }, [ actionButtonRef.current ]);

  /* useEffect(() => {
     if (["Jenny Packham", "Reve"].includes(ring.extraData.Label)) {
       setRingOptions('Diamond_Type', 'LGN');
       setRingOptions('Metal', '18');
     } else if (["Lotus"].includes(ring.extraData.Label)) {
       setRingOptions('Diamond_Type', 'GNU');
     }
   }, [ring.extraData.Label,ring.options["Diamond_Type"]])*/
  return {
    rpid,
    uuid,
    builder_mode,
    handlePDPOptions,
    handle3DObjectView,
    navigate,
    productName,
    handleAllOptions,
    styleId,
    handleSelectSetting,
    fieldValidation,
    isEditableRingOptions,
    weddingBand,
    ringPrice,
    handleWeddingBand,
    updateBandMetalUrl,
    setShowError,
    isDisabledOption,
    handleReviewClick,
    isLoading: loading,
    isStuds,
    isSettingPage,
    isListingRing
  };
};
export default usePdpBuilder;
